import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { setGuestViewChatPropsResolver } from './lazy-route-props'

export async function guestViewChatBeforeEnter (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> {
  const { guestViewChatPropsFn } = await import('./guestViewChatPropsFn')
  setGuestViewChatPropsResolver(guestViewChatPropsFn)
  if (!to.meta) {
    to.meta = {}
  }
  to.meta.viewChatProps = guestViewChatPropsFn()
  next()
}
